import {Sluzba} from "../model/user/sluzba.entity";
import {SluzbaEnum} from "./enums";
import {Stat} from "../model/ciselniky/stat.entity";

// konstanty hlavne pre inicializaciu asociacii, nechce sa mi to nacitavat z DB

export const sluzbaStreetwork: Sluzba = {id: 6, kod: SluzbaEnum.streetwork} as Sluzba;

export const sluzbaNoclaharen: Sluzba = {id: 4, kod: SluzbaEnum.noclaharen} as Sluzba;

// specialny zaznam pouzivany ak REACT_APP_ZDIELANIE_KLIENTOV=VSETKY_UDAJE (klienti su zdielani pre vsetky sluzby)
export const sluzbaZdielaniKlienti: Sluzba = {id: 1000, kod: SluzbaEnum.zdielaniKlienti} as Sluzba;

export const statSlovensko: Stat = {id: 1, nazov: 'Slovensko'} as Stat;
